module.exports = __webpack_public_path__ + "img/kn.bde74c6d.svg";